import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { axiosDefaultHeader, dcpBaseUrl } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import { useAuth } from './useAuth'

export interface DcpUserInfo {
  id: string
  username: string
  firstName?: string
  lastName?: string
  role?: string
}

interface DcpUserListResponse {
  list: DcpUserInfo[]
  count: number
}

interface ResultDcpUserList {
  success: boolean
  info?: DcpUserListResponse
  message?: string
}

interface DCPUserListGetProps {
  execUserListGet: (start?: number, size?: number, filter?: string) => Promise<ResultDcpUserList>
  loading: loadStatus
}

// DCP APIからテナント所属ユーザー一覧取得
export const useDCPUserListGet = (): DCPUserListGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()

  const execUserListGet = async (start: number = 0, size: number = 100, filter: string = '') => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }

      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const response = await axios.get(
        `${dcpBaseUrl}/Users`,
        {
          headers: header,
          params: {
            start,
            size,
            ...(filter.trim() !== '' ? { filter: filter.trim() } : {}),
          },
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }

      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execUserListGet, loading }
}
